import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(app)/(footer)/(legal)/_PageSections/TermsAndCondition.tsx");
